import React from "react";
import ChatPage from "./components/chatpage/ChatPage";

const ChatAIMainPage = () => {
  return <ChatPage />;
};

export default ChatAIMainPage;
